export default "__VITE_ASSET__CHl8E1Vu__"